function Hero() {
  return (
    <section className="hero section scroll-reveal" id="home">
      <div className="container hero-content">
        <div className="hero-text">
          <p className="eyebrow">Software Engineer</p>

          <h1>
            I build scalable, production-ready systems and modern web applications.
          </h1>

          <p className="hero-description">
            Full-stack software engineer building scalable applications and 
            data-driven systems, with experience developing and supporting GIS-based 
            solutions in production environments. Based in Des Moines, IA.
          </p>

          <div className="hero-actions">
            <a href="#projects" className="btn btn-primary magnetic">
              View Projects
            </a>
            <a href="#contact" className="btn btn-secondary magnetic">
              Contact Me
            </a>
            <a
              href="https://github.com/dtomlinson44"
              target="_blank"
              rel="noreferrer"
              className="btn btn-secondary magnetic"
            >
              GitHub
            </a>
          </div>
        </div>

        <div className="hero-card">
          <div className="hero-card-inner">
            <p className="card-label">Currently focused on</p>
            <ul>
              <li>Shipping scalable, production-ready applications</li>
              <li>Owning backend features end-to-end</li>
              <li>Refining engineering and system design skills</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
